module.exports = __webpack_public_path__ + "img/back04.304493de.jpg";